export const rolesAuthorizedSir = [
  'superadmin',
  'admin',
  'projectleader',
  'planner',
  'superintendent'
];

export const getCurrentUserRole = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  return user?.role;
};
